<template>
  <div class="pnlModelSetItem">
    <img class="imgFolder" src="@/assets/img/models/folder.png" />
    <div class="pnlFolderBg" @click.self="IntoFolder">
      <label class="lblModelSetName" @click.self="IntoFolder">{{titleName}}</label>
      <div class="pnlFolderHover">
        <img class="imgHover" src="@/assets/img/models/icon_folder_menu.png" />
        <div class="pnlFolderTools">
          <img class="imgIconArrow" src="@/assets/img/menu/icon_arrow_2.png" />
          <div class="btnFolderTools imgIconEdit" @click.self="RenameDialog">{{txtEdit}}</div>
          <div class="btnFolderTools imgIconDel" @click.self="DelDialog">{{txtDel}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FolderModel",
  props: {
    titleName: String,
    txtEdit: String,
    txtDel: String
  },
  methods: {
    IntoFolder() {
      this.$emit("into-folder");
    },
    RenameDialog() {
      this.$emit("rename");
    },
    DelDialog() {
      this.$emit("show-del");
    }
  }
};
</script>
